import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerSubscription } from '@adornis/baseql/metadata/register.js';
import { watchQuery } from '@adornis/baseql/server/watchQuery.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { gateNexusSubscription } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { map, type Observable } from 'rxjs';
import { RouteOptimizationResult } from '../entities/RouteOptimizationResult.js';

const defaultRoutePlanningLimit = 25;

export const subscribeRoutePlannings = registerSubscription({
  operationName: 'subscribeRoutePlannings',
  type: () => [RouteOptimizationResult],
  resolve:
    (limit = defaultRoutePlanningLimit) =>
    (_gqlFields: BaseQLSelectionSet<RouteOptimizationResult>) => {
      const normalizedLimit = Math.max(1, Math.min(limit, 100));
      return gateNexusSubscription(NexusPermission.RoutePlanning, () =>
        watchQuery('route-plannings', { type: 'Dell' }, { sort: { createdAt: -1 }, limit: normalizedLimit }).pipe(
          map(data => data ?? []),
        ),
      ) as Observable<RouteOptimizationResult[]>;
    },
  params: [{ name: 'limit', type: () => Int }],
});
